import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getTraderMapProjects} from '../../../apis/tradermap_project/list'

const useQueryTraderMapProjects = (active?: boolean) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.tradermap.getTraderMapProjects(active),
        queryFn: async () => {
            const {data} = await getTraderMapProjects(active)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data: data, refetch}
}

export default useQueryTraderMapProjects
